import { listStoreBuilder } from '@/main/store/pages/list/builder';

import { apiProvider } from '../api';
import { CRUMB_LABEL_KEY, NAME } from '../constants';

export const store = listStoreBuilder({
	name: NAME,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	filter: {},
	tableSetting: {},
	rowDetail: null,
	localState: {},
	extraActions: {},
	extraMutations: {},
	extraGetters: {},
	props: {
		filter: {
			PujcovnapaId: null as number | null,
			FakturaceDatOd: null as string | null,
			FakturaceDatDo: null as string | null,
			VozidlopaId: null as string | null,
			OstatnipaId: null as string | null,
		},
		mode: null,
		afterRowSelection: () => {},
	},
});
